import { defineNuxtPlugin, useNuxtApp, computed, watch, onUnmounted, unref } from "#imports";
const normalizeLocales = (locales) => {
  if (Array.isArray(locales)) {
    return locales.reduce((acc, locale) => {
      acc[locale] = {};
      return acc;
    }, {});
  } else if (typeof locales === "object" && locales !== null) {
    return locales;
  }
  return {};
};
export default defineNuxtPlugin(() => {
  const defineI18nRoute = async (routeDefinition) => {
    const { $getLocale, $mergeGlobalTranslations } = useNuxtApp();
    let currentLocale = computed(() => $getLocale());
    const normalizedLocales = normalizeLocales(routeDefinition.locales);
    const updateTranslations = () => {
      const localeValue = unref(currentLocale);
      if (localeValue && normalizedLocales[localeValue]) {
        $mergeGlobalTranslations?.(normalizedLocales[localeValue]);
      }
    };
    updateTranslations();
    if (import.meta.client) {
      let stopWatcher = watch(currentLocale, updateTranslations);
      onUnmounted(() => {
        if (stopWatcher) {
          stopWatcher();
          stopWatcher = null;
          currentLocale = null;
        }
      });
    }
  };
  return {
    provide: {
      defineI18nRoute
    }
  };
});
